import { processingSessionItemIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";
import { ProcessingSession } from "./processing-session";

export const assignLotToReturnItem = {
  name: "assignLotToReturnItem" as const,
  input: z.object({
    sessionItemId: processingSessionItemIdFormat.schema,
    lotNumber: z.string(),
    expirationDate: z.date().nullable(),
  }),
  output: z.object({ session: ProcessingSession }),
};
